import React from 'react';
import PropTypes from 'prop-types';
import { ProgressbarStyles } from '../../styles/StyleComponents';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Parametros props
//title: Título de la barra de carga
//progress: el porcentaje de avance
//buffer: maximo a llegar

LinearProgressWithLabel.propTypes = {
  title: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  buffer: PropTypes.number.isRequired,
};

LinearProgressWithLabel.defaultProps = {
  title: "Cargando...",
  progress: 0,
  buffer: 100
}

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" height="100%" mr={1}>
        <Typography style={{ fontWeight: 'bold', fontSize: 17 }} variant="body2" color="textSecondary">{props.title}</Typography>
        <LinearProgress width="100%" height="100%" variant="buffer" style={{ height: 15, borderRadius: 3 }} {...props} />
        <Typography variant="body2" color="textSecondary">{`.`}</Typography>
      </Box>
      <Box minWidth={35}>
        <Typography style={{ fontWeight: 'bold', fontSize: 17 }} variant="body2" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const ProgressBar = (props) => {
  const classes = ProgressbarStyles();

  return (
    <div className={classes.root}>
      <LinearProgressWithLabel value={props.progress} valueBuffer={props.buffer} />
    </div>
  );
}

export default React.memo(ProgressBar);